import React from "react";

import { isEmpty } from "ramda";

import { Pagination, Table } from "components/Common/clearsense-ui/components";
import NoData from "components/Common/NoData";

const PeopleTable = ({ peopleData, columns, userPermissions }) => {
  if (isEmpty(peopleData)) {
    return (
      <NoData
        entity="People"
        actionLabel="Associate People"
        onAction={() => ""}
        currentPermissions={userPermissions}
        acceptablePermissions="associate"
      />
    );
  }

  return (
    <div className="flex flex-col flex-grow mt-8">
      <Table
        rowData={peopleData}
        columnData={columns.selected}
        rowKey={record => record.id}
      />
      <Pagination
        currentPage={1}
        pageSize={7}
        showResultsPerPage
        totalRecordsCount={100}
        className="p-2 mt-auto"
      />
    </div>
  );
};

export default PeopleTable;
